export * from './wealth-happy-screen.component';
